import { getInstance } from "@/auth/authWrapper";
import cfg from "../../config";

export interface ProjectRealtimeSnapshot {
    projectId: string
    // Ключ — путь внутри документа проекта ('loading', 'initChisai/GCB2', ...)
    values: Record<string, any>
}

/**
 * Вход в комнату проекта через бэкенд: он проверяет права (в т.ч. доступ ко всем проектам),
 * добавляет сокеты пользователя в комнату `projectId:<id>` и возвращает текущие значения
 * realtime-полей проекта — то, что раньше приходило первым value-событием Firebase.
 */
export async function joinProjectRealtime(projectId: string): Promise<ProjectRealtimeSnapshot> {
    const auth = getInstance();
    const token = await auth.getTokenSilently();
    const url = new URL(`${cfg.apiEndpoint}/realtime/joinProject`);
    const options = {
        method: "POST",
        headers: { "content-type": "application/json", "Authorization": `Bearer ${token}` },
        body: JSON.stringify({ projectId }),
    };
    const res = await fetch(url.toString(), options);
    if (res.status > 300) {
        throw new Error(`joinProjectRealtime failed: ${res.status}`);
    }
    return res.json();
}
